import { SxProps, Theme } from '@mui/material';

export const sectionBoxSx: SxProps<Theme> = {
  backgroundColor: '#161616',
  borderRadius: 1,
  overflow: 'hidden'
};

export const headerSx: SxProps<Theme> = {
  backgroundColor: '#464545',
  p: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};

export const headerLeftSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

export const avatarSx: SxProps<Theme> = {
  backgroundColor: 'white',
  borderRadius: '50%',
  width: 24,
  height: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const avatarTextSx: SxProps<Theme> = {
  color: '#3F51B5',
  fontWeight: 'bold',
  fontSize: '0.875rem'
};

export const headerTitleSx: SxProps<Theme> = {
  color: 'white',
  fontWeight: 600
};

export const modifyButtonSx: SxProps<Theme> = {
  color: 'white',
  borderColor: 'white',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderColor: 'white'
  }
};

export const contentBoxSx: SxProps<Theme> = {
  p: 3
};

export const gridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
  gap: 3,
  rowGap: 2.5
};

export const labelSx: SxProps<Theme> = {
  color: '#9E9E9E',
  fontSize: '0.875rem',
  mb: 0.5
};

export const valueSx: SxProps<Theme> = {
  color: '#FFFFFF',
  fontWeight: 400
};

export const textFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    color: 'white',
    '& fieldset': { borderColor: '#666' },
    '&:hover fieldset': { borderColor: '#999' },
    '&.Mui-focused fieldset': { borderColor: '#3F51B5' }
  },
  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)' }
};

export const selectSx: SxProps<Theme> = {
  color: 'white',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#666' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#999' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3F51B5' },
  '& .MuiSvgIcon-root': { color: 'white' }
};

export const addressFieldSx: SxProps<Theme> = {
  gridColumn: '1 / -1',
  '& .MuiOutlinedInput-root': {
    color: 'white',
    '& fieldset': { borderColor: '#666' },
    '&:hover fieldset': { borderColor: '#999' },
    '&.Mui-focused fieldset': { borderColor: '#3F51B5' }
  },
  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)' }
};

export const editActionsSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
  mt: 3,
  pt: 2,
  borderTop: '1px solid rgba(255, 255, 255, 0.1)'
};

export const cancelButtonSx: SxProps<Theme> = {
  color: 'white',
  borderColor: 'white',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderColor: 'white'
  }
};

export const saveButtonSx: SxProps<Theme> = {
  backgroundColor: '#3F51B5',
  '&:hover': {
    backgroundColor: '#303F9F'
  }
};